import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { formatDate } from 'src/app/shared/commen-function-file';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MatSelectChange } from '@angular/material/select';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { ElcmGenericServiceService } from '../_elcm-services/elcm-generic-service.service';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-elcm-termination',
  templateUrl: './elcm-termination.component.html',
  styleUrls: ['./elcm-termination.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ElcmTerminationComponent implements OnInit {
  @Input() terminationReport: any;
  buttonColorName: any;
  terminationForm!: FormGroup;
  loggedInUserRole: any | null;
  loggedInUserName: any | null;
  adminAccessData: any = [];
  userEmail: any | null;
  updateEmployeeData: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserCompanyID: any;
  loggedInUserId: any | null;
  todayDate: Date = new Date();
  checkType: any
  loggedInCompanyMDID: any;
  terminatedEmployee: any = []
  today = formatDate(new Date());
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<ElcmTerminationComponent>,
    @Inject(MAT_DIALOG_DATA) public Employeedata: any, private config: Config, private encryptionService: EncryptionService,
    private httpService: HttpService, public dialog: MatDialog, private datePipe: DatePipe, private elcmGenericService: ElcmGenericServiceService) {
    this.updateEmployeeData = Employeedata?.employeeData;
    this.checkType = Employeedata.type;
    this.terminatedEmployee = Employeedata?.terminatedEmployee
    console.log(this.terminatedEmployee);

    this.terminationForm = this.fb.group({
      employeeName: ['', Validators.required],
      employeeBand: [{ value: '', disabled: true }],
      employeeGrade: [{ value: '', disabled: true }, Validators.required],
      employeeDepartment: [{ value: '', disabled: true }, Validators.required],
      employeeDesignation: [{ value: '', disabled: true }, Validators.required],
      terminationDate: [{ value: '', disabled: true }, Validators.required],
      terminationReason: ['', [Validators.required, Validators.maxLength(255)]],
      lastWorkingDate: ['', Validators.required],
      personalMailId: ['', [Validators.required, Validators.email, Validators.maxLength(100)]],
      hodCode: [''],
      managerCode: [''],
      empCode: [''],
      userOfficialEmail: [''],
      hrMail: ['']
    });
  }

  ngOnInit(): void {

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInCompanyMDID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInCompanyMDID')));
    this.userEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      if (this.loggedInUserRole == 'Admin') {
        this.elcmGenericService.getAllAccessMatrix(this.loggedInUserCompanyID).subscribe({
          next: (data: any) => this.adminAccessData = (data?.status && data?.data?.access[0]) ? data?.data?.access[0] : []
        });
      }
    }
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.getpmsyearlist()

  }
  hasError(controlName: any, errorType: any) {
    const control = this.terminationForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }

  pmsYears: any = []
  selectedYear: any;
  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      this.getCompanyDataByCompID();



    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }

  emailOfHrAdmin: any;
  checkHRName: any;
  getCompanyDataByCompID() {

    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {

      console.log(data?.data);
      this.checkHRName = data?.data.firstnameOfHrAdmin + data?.data.lastnameOfHrAdmin
      this.emailOfHrAdmin = data?.data?.emailOfHrAdmin;
      this.getUserList();


    })
  }
  patchData() {
    if (this.updateEmployeeData) {
      console.log(this.updateEmployeeData);


      const selectedUser = this.userList.find((user: any) => user.id == this.updateEmployeeData?.userId);


      this.terminationForm.patchValue({
        employeeName: selectedUser?.id || '',
        employeeDepartment: this.updateEmployeeData?.empDepartment || '',
        employeeBand: this.updateEmployeeData?.empBand || '',
        employeeGrade: this.updateEmployeeData?.empGrade || '',
        employeeDesignation: this.updateEmployeeData?.empDesignation || '',
        // terminationDate: this.datePipe.transform(new Date(this.updateEmployeeData?.dateOfTermination), 'MM-dd-yyyy'),
        terminationDate: this.updateEmployeeData?.dateOfTermination,
        terminationReason: this.updateEmployeeData?.terminationReason,
        // lastWorkingDate: this.updateEmployeeData?.lastWorkingDay,
        lastWorkingDate: moment(this.updateEmployeeData?.lastWorkingDay, 'DD-MM-YYYY'),
        personalMailId: this.updateEmployeeData?.personalMailId,
        managerCode: this.updateEmployeeData?.managerCode,
        hodCode: this.updateEmployeeData?.hodCode,
        empCode: this.updateEmployeeData?.empCode,
        userOfficialEmail: this.updateEmployeeData?.userOfficialEmail,
        hrMail: this.updateEmployeeData?.hrMail
      });
      console.log(this.terminationForm);
      this.terminationForm.get('employeeName')?.disable();
    }
  }
  userList: any = []
  fiterUserList: any = []
  getUserList() {
    this.httpService.callGetService(`${this.config.getUserList}/${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      if (res) {
        console.log(this.loggedInCompanyMDID);

        console.log(res);
        this.userList = res.data.filter((elm: any) => parseInt(elm.id) !== this.loggedInCompanyMDID);

        if (this.loggedInUserRole == 'Admin') this.userList = this.elcmGenericService.empFilterForAllEmployeeList(this.userList, this.adminAccessData?.employeeDetails, 'id');

        //Assuming terminatedEmployee is an array of user objects with 'id'
        if (!this.updateEmployeeData) {
          //   this.userList = res.data;
          // } else {
          const terminatedIds = this.terminatedEmployee.map(String);
          console.log(this.emailOfHrAdmin);

          console.log(this.checkHRName, this.userList[0].firstName + this.userList[0].lastName);

          this.userList = this.userList.filter((elm: any) => !terminatedIds.includes(elm?.id) && this.checkHRName != elm.firstName + elm.lastName);
        } else if (this.updateEmployeeData) {
          this.patchData();
        }
        // this.getEployeeData()
      }
    })
  }
  selectedEmployeeId: any;
  onEmployeeChange(event: MatSelectChange): void {
    const selectedEmployeeId = event.value;
    console.log('Selected Employee ID:', selectedEmployeeId);

    this.getEployeeData(selectedEmployeeId)
    // You can now perform any logic using selectedEmployee
  }

  getEployeeData(selectedEmployeeId: any) {
    if (!this.updateEmployeeData) {

      this.httpService.callGetService(`${this.config.getEployeeData}/${this.loggedInUserCompanyID}/${selectedEmployeeId}`).subscribe((res: any) => {
        const employeeData = res.data[0];
        this.selectedEmployeeId = selectedEmployeeId

        console.log(employeeData);


        if (employeeData) {
          this.terminationForm.patchValue({

            employeeDepartment: employeeData?.empDept || '',
            employeeBand: employeeData?.band || '',
            employeeGrade: employeeData?.grade || '',
            employeeDesignation: employeeData?.empDesignation || '',
            terminationDate: this.today,
            managerCode: employeeData?.reportingManagerCode,
            hodCode: employeeData?.hodCode,
            empCode: employeeData?.emplCode,
            userOfficialEmail: employeeData?.officialEmail,
            hrMail: this.emailOfHrAdmin

          });
        }
      });
    }



  }
  isSubmitting = false; // Prevent multiple submissions
  addSubmitForm = false
  onSubmit() {
    if (this.isSubmitting) return; // Prevent duplicate API calls

    if (this.terminationForm.invalid) {
      this.addSubmitForm = true;
      this.terminationForm.markAllAsTouched();
      return;
    }
    this.isSubmitting = true; // Set flag to prevent multiple calls

    let formData
    const selectedEmployee = this.userList.find((emp: any) => emp.id === this.selectedEmployeeId);


    formData = {
      terminationFormId: this.updateEmployeeData?.terminationFormId || null,
      hrId: this.loggedInUserId,
      userId: this.selectedEmployeeId || this.updateEmployeeData?.userId,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear,
      fiscalYear: this.loggedInCompanyFiscalyear,
      empName: selectedEmployee
        ? `${selectedEmployee.firstName} ${selectedEmployee.lastName}`
        : this.updateEmployeeData?.empName,
      empDepartment: this.terminationForm.getRawValue()?.employeeDepartment,
      empGrade: this.terminationForm.getRawValue()?.employeeGrade,
      empBand: this.terminationForm.getRawValue()?.employeeBand,
      empDesignation: this.terminationForm.getRawValue()?.employeeDesignation,
      dateOfTermination: this.terminationForm.getRawValue()?.terminationDate,
      // dateOfTermination:this.datePipe.transform(this.terminationForm.getRawValue()?.terminationDate, 'dd/MM/yyyy'),
      terminationReason: this.terminationForm.getRawValue()?.terminationReason,
      // lastWorkingDay: this.terminationForm.getRawValue()?.lastWorkingDate,
      lastWorkingDay: formatDate(this.terminationForm.getRawValue()?.lastWorkingDate),
      personalMailId: this.terminationForm.getRawValue()?.personalMailId,
      managerCode: this.terminationForm.getRawValue()?.managerCode,
      hodCode: this.terminationForm.getRawValue()?.hodCode,
      empCode: this.terminationForm.getRawValue()?.empCode,
      userOfficialEmail: this.terminationForm.getRawValue()?.userOfficialEmail,
      hrMail: this.terminationForm.getRawValue()?.hrMail,
      revolveStatus: false
    };


    this.httpService.callPostService(`${this.config.terminationform}`, formData).subscribe(
      (response: any) => {
        this.showPopup(response.message, 'success', true);
        this.isSubmitting = false; // Reset flag

      },
      (error: any) => {
        this.showPopup(error.error.error || 'An error occurred.', 'danger', false);
        this.isSubmitting = false; // Reset flag
      }
    );
  }
  // Reusable popup function
  showPopup(message: string, color: string, isSuccess: boolean) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: color,
        showSuccessIcon: isSuccess,
        showSuccessMessage: false,
        showCloseIcon: !isSuccess
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (isSuccess) this.dialogRef.close(); // Close only on success
    });
  }
  onCancel() {
    this.dialogRef.close();
  }
}
